import React from "react";
import Herobanner from "./Herobanner.jsx";
import Homewhatwedo from "./Homewhatwedo.jsx";
import PlatformFeatures from "./PlatformFeatures.jsx";
import HRPlatformSection from "./HRPlatformSection.jsx";
import Clint from "./Clint.jsx";
import Possubscription from "./Possubscription.jsx";
import WallOfLove from "./WallOfLove.jsx";
import Perfonce from "./Perfonce.jsx";
import Footer from "./Footer.jsx";


const HomePage = () => {
  return (
    <div style={{marginTop:"60px"}}>
     
      <Herobanner />
      <PlatformFeatures/>
      <HRPlatformSection/>
      <Clint/>
      <Possubscription/>
      <WallOfLove/>
      <Perfonce/>
      <Footer/>
      
      {/* <Homewhatwedo/> */}
    
    </div>
  );
};

export default HomePage;
